import React, { PureComponent } from 'react';

import { formatTimestamp } from "../../util";

import Togglable from '../togglable';

function processComments(comments, intervals, position, duration) {
	var aResult = [],
		i = 0,
		maxCount = 0;

	for (i=0; i<intervals; i++) {
		aResult.push({
			index: i,
			label: "",
			lowerTimestamp: i/intervals*duration,
			upperTimestamp: (i+1)/intervals*duration,
			middlePercentage: ((i+0.5)/intervals*100).toFixed(2) + "%",
			count: 0,
			height: "0%",
			active: false,
			comment: null
		});
	}

	const activeInterval = Math.min(Math.floor(position / duration * intervals), intervals - 1);
	if (aResult[activeInterval] !== undefined) {
		aResult[activeInterval].active = true;
	}

	aResult = comments.reduce((result, comment)=>{
		if (comment.comment_type.slice(0, 9)==="archived_") {
			return result;
		}

		var index = Math.floor(comment.timestamp/duration*intervals);

		if (comment.timestamp !== 0) {
			result[index].count++;
		}
		maxCount = Math.max(maxCount, result[index].count);

		if (result[index].comment === null) {
			result[index].comment = comment;
		}

		return result;
	}, aResult);

	for (i=0; i<intervals; i++) {
		aResult[i].height = (aResult[i].count / maxCount * 100).toFixed(6).toString()+"%";
		aResult[i].label = formatTimestamp(Math.floor(aResult[i].lowerTimestamp))+"-"+formatTimestamp(Math.ceil(aResult[i].upperTimestamp))+" - "+aResult[i].count+" "+(aResult[i].count===1?"comment":"comments");
	}

	return aResult;
}

const ScrubberComment = Togglable(({ iframe, comment, middlePercentage, goToComment }) => (
	comment
	? <div className="bg-dark-4">
		<div className={iframe?"container":""}>
			<div className="gui-timeline-comment">
				<div className="gui-timeline-comment-user">
					<div>
						<span>{comment.creator.name}</span>
					</div>
					<div className="active" style={{left:middlePercentage}}>
						<span>{comment.creator.name}</span>
					</div>
					<div>
						<span>{comment.creator.name}</span>
					</div>
				</div>
				<div className="gui-timeline-comment-body text-truncate">
					<a onClick={()=>goToComment(comment.objectid)}>{comment.body}</a>
				</div>
			</div>
		</div>
	</div>
	: <div className="bg-dark-4">
		<div className={iframe?"container":""}>
			<div className="gui-timeline-comment">
				<div className="gui-timeline-comment-user">&nbsp;</div>
				<div className="gui-timeline-comment-body text-truncate">&nbsp;</div>
			</div>
		</div>
	</div>
))

class Scrubber extends PureComponent {
	render() {
		var { iframe, data, duration, position, goToComment, seek } = this.props;

		return <div aria-expanded="true" className="collapse gui-timeline-container show" id="collapse-gui-timeline">
			<div className={iframe?"container":""}>
				<div className="gui-timeline">
					<div className="gui-timeline-marker" style={{width:(position/duration*100).toFixed(4).toString()+"%"}}></div>

					<div className="html-chart-wrapper">
						<div className="html-chart-main" ref={(c)=>this._chart=c} onClick={({clientX})=>{seek(Math.floor((clientX-this._chart.getBoundingClientRect().left)/this._chart.offsetWidth*duration))}}>
							{data.map((bar)=><div key={"bar-"+bar.index} className="html-chart-bar">
								<a className="html-chart-bar-positive" style={{height:bar.height}} title={bar.label}></a>
							</div>)}
						</div>
					</div>
				</div>
			</div>

			{data.map((props, index)=><ScrubberComment key={"current-"+index} visible={props.active} iframe={iframe} goToComment={goToComment} {...props} />)}
		</div>;
	}
}

const intervals = 45
const ScrubberWrapper = Togglable(({ comments, visible, duration, position, ...rest }) => (
	<Scrubber comments={comments.filter(({comment_type}) => comment_type.slice(0, 9) !== "archived_")} duration={duration} position={position} data={processComments(comments, intervals, position, duration)} {...rest} />
))

export default ScrubberWrapper;